import {
    type LensSubmissionType,
    type LensstudioMylensesAdjust,
    type MylensesSubmissionDetailsSource,
} from "@snapchat/blizzard-schema";

export interface AdjustEventData {
    event: LensstudioMylensesAdjust["event_name"];
    source: MylensesSubmissionDetailsSource;
    lensSubmissionType: LensSubmissionType;
}

export const createAdjustEvent = ({ event, source }: AdjustEventData): LensstudioMylensesAdjust => ({
    event_name: event,
    event_value: source,
});
